import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
} from "@angular/core";
import { ViewChildren, QueryList } from "@angular/core";
import { PlanningService } from "../../../_services/planning.service";
import { CompanyService } from "../../../_services/company.service";
import { PlaceService } from "../../../_services/place.service";
declare var jQuery: any;
import "../../../../assets/semantic/semantic.min.js";
import { FormArray, FormGroup, FormBuilder, FormControl, Validators, AbstractControl, ValidationErrors} from "@angular/forms";
import { IMyDpOptions } from "mydatepicker";

import { CityAutocompleteComponent } from "../../city-autocomplete/city-autocomplete.component";
import { CompanyAutocompleteComponent } from "../../company-autocomplete/company-autocomplete.component";
import { WarehouseAutocompleteComponent } from "../../warehouse-autocomplete/warehouse-autocomplete.component";

import { PlanningFilesService } from "../../../_services/planning-files.service";
import { FileUploadService } from "../../../_services/FileUploadService";

//import { ConfigService } from "../../../_services/config.service";
//import { DistanceService } from "../../../_services/distanceService";
import { Co2Service } from "../../../_services/co2.service";
import { ToastService } from "../../../_services/toast.service";

@Component({
  selector: "app-new-planning",
  templateUrl: "./new-planning.component.html",
  styleUrls: ["./new-planning.component.css"],
})
export class NewPlanningComponent implements OnInit {

  @Output() updatePlanningFiles: EventEmitter<object> = new EventEmitter<object>();

  palettes: FormGroup;
  new_planning: FormGroup;
  new_company: FormGroup;

  @ViewChildren('citycomp' ) childCity:QueryList<CityAutocompleteComponent>;
  @ViewChildren('companycomp') childCompany: QueryList<CompanyAutocompleteComponent>;
  @ViewChildren('warehousecomp') childWarehouse: QueryList<WarehouseAutocompleteComponent>;
  
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  private creating_planning: boolean;
  private add_company = false;
  private errorMessage = "";

  private planningFileToUpload: File | null = null;
  private planning_files: Array<Object> | null = null;
  private addPlanningFileLoading: boolean = false;
  temporaryFiles: { file: File, title: string }[] = [];
  selectedFile: File = null;
  private deletePlanningFileLoadingID: Array<number> = [];

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy",
    openSelectorOnInputClick: true,
    editableDateField: false,
  };

  constructor(
    private elRef: ElementRef,
    private service: PlanningService,
    private planningFilesService: PlanningFilesService,
    private company_service: CompanyService,
    private place_service: PlaceService,
    private fb: FormBuilder,
    private toast: ToastService,
    private fileUploadService: FileUploadService,
   // private configService: ConfigService,
    //private distanceService: DistanceService,
    private co2Service: Co2Service
  ) {}

  ngOnInit() {
    this.new_planning = this.fb.group({
      planning: this.fb.group({
        number: new FormControl(),
        client_id: new FormControl("", [Validators.required]),
        transporter_id: new FormControl("", [Validators.required]),
        receiver_id: new FormControl(),
        departure_id: new FormControl("", [Validators.required]),
        arrival_id: new FormControl("", [Validators.required]),
        planning_palettes: this.fb.array([], this.validatePlanningPalettesNotEmpty)
      }),
      planning_details: this.fb.group({
        state: new FormControl(),
        ref_client: new FormControl(),
        ref_loading: new FormControl(),
        ref_delivery: new FormControl(),
        vehicle: new FormControl("", [Validators.required]),
        quantity: new FormControl("", [Validators.required]),
        departure_date: new FormControl("", [Validators.required]),
        arrival_date: new FormControl(),
        loading_hour: new FormControl(),
        shipping_hour: new FormControl(),
        loading_place: new FormControl(),
        shipping_place: new FormControl(),
      }),
      price_ref: this.fb.group({
        buy_price: new FormControl(""),
        single_buy_price: new FormControl(""),
        sell_price: new FormControl(""),
        single_sell_price: new FormControl(""),
        note: new FormControl(),
        ref: new FormControl(),
      }),
      planning_files: this.fb.group({
        planning_file: new FormControl(),
        planning_file_title: new FormControl(),
      }),
      planning_emit: this.fb.group({
        etape_porteur_1: new FormControl(),
        etape_porteur_2: new FormControl(),
        co2_emis: new FormControl(),
      })
    });

    this.new_company = this.fb.group({
      email: new FormControl(""),
      name: new FormControl("", [Validators.required]),
      phone: new FormControl(""),
    });
  }


  //permet de s'assurer qu'il y a au moins une ligne de palettes
  validatePlanningPalettesNotEmpty(control: AbstractControl): ValidationErrors | null {
    const planingPalettes = control as FormArray;

    if (planingPalettes.length === 0) {
      return { emptyPalettes: true };
    }

    return null;
  }

  get itemsFormArray(): FormArray {
    return this.new_planning.get('planning.planning_palettes') as FormArray;
  }
 //ajouter une ligne de palette
  addItem(): void {
    if (this.itemsFormArray.length < 4) {
      const item = this.fb.group({
        warehouse_id: ['', Validators.required],
        chargees: ['', Validators.required],
        type: '',
        rendues: '',
        livrees: '',
        reprises: '',
        warehouse_shipping_id: ['', Validators.required]
      });

      this.itemsFormArray.push(item);
    }
  }

  //supprimer une ligne de palette
  removeItem(index: number): void {
    this.itemsFormArray.removeAt(index);
    //recalcul de la quantité total
    this.calculateTotalQuantity();
  }

  //calcul quantité totale et set le champ quantité
  calculateTotalQuantity(): void {
    let totalQuantity = 0;

    // Itère à travers les éléments du FormArray
    for (const itemGroup of this.itemsFormArray.controls) {
      const chargeesControl = itemGroup.get('chargees') as FormControl;
      const chargeesValue = +chargeesControl.value; // Convertit en nombre
      // Vérifie si la valeur de "chargees" est numérique
      if (!isNaN(chargeesValue)) {
        totalQuantity += chargeesValue;
      }
    }
    // Met à jour le champ "quantity" dans le groupe principal
    this.new_planning.get('planning_details.quantity').setValue(totalQuantity);
  }

  openModal(field_object: { field; value }) {
    if (field_object) {
      if (field_object.field == "departure_id")
        this.new_planning.patchValue({ departure_id: field_object.value });
      if (field_object.field == "arrival_id")
        this.new_planning.patchValue({ arrival_id: field_object.value });
    }

    jQuery("#add-planning-modal").modal({ inverted: true }).modal("show");
    jQuery(".ui.radio.checkbox").checkbox("uncheck");
  }

  closeModal() {
    jQuery("#add-planning-modal").modal({ closable: true }).modal("hide");
    this.refresh.emit(true);
  }

  newCompany(name) {
    this.new_company.patchValue({ name: name });
    this.new_planning.patchValue({ seller: 0 });
    this.add_company = true;
  }

  async submitPlanningForm() {
    if (this.temporaryFiles.some(file => !file.title.trim())) {
      this.toast.error("Veuillez indiquer un titre pour tous les fichiers.", false, "Soumission du formulaire");
      return;
    }
    
    // Calcul du CO2 et mise à jour du champ dans le formulaire
    let departure_id = this.new_planning.value.planning.departure_id;
    let arrival_id = this.new_planning.value.planning.arrival_id;
    let qty = this.new_planning.value.planning_details.quantity;

    const etapePorteur1 = this.new_planning.get('planning_emit.etape_porteur_1').value;
    const etapePorteur2 = this.new_planning.get('planning_emit.etape_porteur_2').value;

    const co2Emission = await this.co2Service.calculateCO2(departure_id, arrival_id, qty, etapePorteur1, etapePorteur2);
    this.new_planning.get('planning_emit.co2_emis').setValue(co2Emission);
    

    this.new_planning.disable();
    this.creating_planning = true; // Disable the loading button apparition
    jQuery("#add-planning-modal").modal({ closable: false });

    //console.log('form value', this.new_planning.value)
    if (
      this.new_planning.value.planning.departure_date &&
      this.new_planning.value.planning.departure_date.formatted
    ) {

      this.new_planning.get('planning.departure_date').setValue(this.new_planning.value.planning.departure_date.jsdate);
    }
    if (
      this.new_planning.value.planning.arrival_date &&
      this.new_planning.value.planning.arrival_date.formatted
    ) {

      this.new_planning.get('planning.arrival_date').setValue(this.new_planning.value.planning.arrival_date.jsdate);
    }
  
    
    if (this.add_company) {
      
      this.new_company.disable();
      this.company_service
        .createCompany(this.new_company.value) // Create the Contact
        .subscribe((response) => {
          this.new_planning.patchValue({ seller: response.id });
          this.createPlanning();
        });
    } else {
      
      this.createPlanning();
    }
  }

  /*
  async calculateDistance(departureCityId: number, arrivalCityId: number): Promise <number> {
    try {
      // Obtenir les coordonnées des villes à partir de leurs IDs
      const coordinates = await this.distanceService.getCoordinatesByCityIds(departureCityId, arrivalCityId);

      // Calculer la distance entre les deux villes
      const distance = await this.distanceService.calculateDistance(coordinates.departure, coordinates.arrival);
      return distance;
    } catch (error) {
      console.error('Erreur lors du calcul de la distance', error);
    }
  }

  async calculateCO2(departure_id: number, arrival_id: number, quantity: number): Promise<number> { 
   
    const distance = await this.calculateDistance(departure_id, arrival_id);
    const etapePorteur1 = this.new_planning.get('planning_emit.etape_porteur_1').value;
    const etapePorteur2 = this.new_planning.get('planning_emit.etape_porteur_2').value;
    
    
    let co2Emission = 0;

    if (quantity > 20 && quantity <= 33) {
      // Camion complet
      co2Emission = await this.calculateFullTruckCO2(distance)
      
    } else if (quantity < 20) {
      // Groupage
      co2Emission = await this.calculateGroupedTruckCO2(etapePorteur1, etapePorteur2, distance, quantity); // Calcul pour un camion en groupage
    }

    return co2Emission;
  }

  async calculateFullTruckCO2(distance: number): Promise<number> {
    try {
      // Récupérer la consommation du véhicule
      const consoVehiculeResponse = await this.configService.getConfigByKey('conso_vehicule').toPromise();
      const conso_vehicule = consoVehiculeResponse.value;
      console.log('Conso véhicule:', conso_vehicule);

      // Récupérer l'indice de rejet
      const indiceRejetResponse = await this.configService.getConfigByKey('indice_rejet').toPromise();
      const indice_rejet = indiceRejetResponse.value;
      console.log('Indice de rejet:', indice_rejet);

      // Calcul du rejet de CO2
      const rejet = (conso_vehicule * distance / 100) * indice_rejet;
      console.log('Rejet:', rejet);
      return rejet;

    } catch (error) {
      console.error('Erreur lors de la récupération des configs:', error);
      return 0; // Retourner 0 en cas d'erreur
    }
  }

  async calculateGroupedTruckCO2(etapePorteur1: number, etapePorteur2: number, distance: number, qty: number): Promise<number> {
    //conso_vehicule_porteur1 x nb km / 100 x %de palette (/20) x indece de rejet
    //conso_Vehicule x nb km / 100 x %de palette(/33) x indece de rejet
    //conso_vehicule_porteur2 x nb km / 100 x %de palette (/20) x indece de rejet
    try {
      // Récupérer la consommation du véhicule
      const consoVehiculeResponse = await this.configService.getConfigByKey('conso_vehicule').toPromise();
      const conso_vehicule = consoVehiculeResponse.value;
      console.log('Conso véhicule:', conso_vehicule);

      // Récupérer l'indice de rejet
      const indiceRejetResponse = await this.configService.getConfigByKey('indice_rejet').toPromise();
      const indice_rejet = indiceRejetResponse.value;
      console.log('Indice de rejet:', indice_rejet);

      const consoVehiculePorteurResponse = await this.configService.getConfigByKey('conso_vehicule_porteur').toPromise();
      const conso_vehicule_porteur = consoVehiculePorteurResponse.value;
      console.log('Conso véhicule Porteur:', conso_vehicule_porteur);

      //Trajet porteur 1
      const percentPalette = qty/20;
      const etape1 = conso_vehicule_porteur * etapePorteur1 / 100 * percentPalette * indice_rejet
      //trajet porteur 2
      const etape2 = conso_vehicule_porteur * etapePorteur2 / 100 * percentPalette * indice_rejet
      //trajet central
      const rejet = (conso_vehicule * distance / 100) * indice_rejet;
      
      const total = etape1 + etape2 + rejet;
      console.log('Rejet:', total);
      return total;

    } catch (error) {
      console.error('Erreur lors de la récupération des configs:', error);
      return 0; // Retourner 0 en cas d'erreur
    }
  }
*/
  historyFill(transport) {

    this.new_planning.get('planning.transporter_id').setValue(transport.transporter_id);
  
    if (transport.copy_price) {
      this.new_planning.get('price_ref.buy_price').setValue(transport.buy_price);
      this.new_planning.get('price_ref.single_buy_price').setValue(transport.single_buy_price);
      this.new_planning.get('price_ref.sell_price').setValue(transport.sell_price);
      this.new_planning.get('price_ref.single_sell_price').setValue(transport.single_sell_price);

    }
  }

  createPlanning() {
  
    //console.log(this.new_planning.value);
    this.service
      .createPlanning(this.new_planning.value)
      .subscribe((response) => {
        this.closeModal(); // Set the modal closable & Close the modal
        
        this.uploadPlanningFiles(response.id)
        
        this.creating_planning = false; // Disable the loading button apparition
        this.add_company = false;
        this.new_planning.enable(); // Re Enable the Form
        this.new_planning.reset(); // Reset It
        
        //reset des champs autocomplete 
        this.childCity.forEach((child) => { child.selectResult({ id: null, name: '' }) });
        this.childCompany.forEach((child) => { child.selectResult({ id: null, name: '' }) });
        this.childWarehouse.forEach((child) => { child.selectResult({ id: null, name: '' }) });
        jQuery("#add-planning-modal")
          .find(".dropdown")
          .dropdown("set value", "");
        jQuery("#add-planning-modal")
          .find(".dropdown")
          .dropdown("set text", "");
        this.refresh.emit(true); // Emmit the refresh Event
      });
  }
  /* FILES */
  
  handlePlanningFileInput(files: FileList) {
    if (files.length > 0) {
      this.selectedFile = files.item(0);
    }
  }
  
  resetPlanningFileData() {
    this.new_planning.get('planning_files').reset();
  }

  removeFile(index: number) {
    this.temporaryFiles.splice(index, 1);
  }

  
  addPlanningFile() {
    const titleControl = this.new_planning.get('planning_files').get('planning_file_title');
    const title = titleControl.value;
    
    if (!this.selectedFile) {
      this.toast.error("Veuillez sélectionner un fichier.", false, "Ajout d'un document");
      return;
    }

    if (!title || !title.trim().length) {
      this.toast.error("Veuillez saisir un titre pour le document.", false, "Ajout d'un document");
      return
    }

    this.temporaryFiles.push({ file: this.selectedFile, title });
    this.selectedFile = null;
    titleControl.reset();

    //this.resetPlanningFileData();
  }

  uploadPlanningFiles(planningId: string) {
    this.addPlanningFileLoading = true;
    const files = this.temporaryFiles

    files.forEach(fileData => {
      const formData = new FormData();
      formData.append('planning_id', planningId);
      formData.append('planning_file_title', fileData.title);
      formData.append('file', fileData.file);

      this.planningFilesService.addPlanningFile(formData).subscribe(
        (response) => {
          this.toast.success(`Le document '${fileData.title}' a été ajouté avec succès`, false, "Ajout d'un document");
          this.updatePlanningFiles.emit({ planning_file: response, isDeleted: false });
        },
        (error) => {
          console.error('Error uploading file', error);
          this.toast.error(`Une erreur est survenue lors de l'ajout du document '${fileData.title}'.`, false);
        }
      );
    });

    this.addPlanningFileLoading = false;
    this.temporaryFiles = [];
  }

  
  

  deletePlanningFile(planning_file) {
    if (confirm(`Êtes-vous sûr de vouloir supprimer le document '${planning_file.title}' ?`)) {
      this.deletePlanningFileLoadingID.push(planning_file.id);
      this.planningFilesService.deletePlanningFile(planning_file).subscribe(
        (response) => {
          this.toast.success(`Le document '${planning_file.title}' a été supprimé avec succès`, false, "Suppression d'un document");
          this.deletePlanningFileLoadingID = this.deletePlanningFileLoadingID.filter(x => x != planning_file.id);
          this.updatePlanningFiles.emit({ planning_file: response, isDeleted: true });
        },
        (error) => {
          console.error('Error deleting file', error);
          this.toast.error(
            error.error && error.error.message 
              ? error.error.message 
              : `Une erreur est survenue lors de la suppression du document '${planning_file.title}'.`,
            false,
            "Suppression d'un document"
          );
          this.deletePlanningFileLoadingID = this.deletePlanningFileLoadingID.filter(x => x != planning_file.id);
        }
      );
    }
  }

  getPlanningFiles(planning_id) {
    this.planningFilesService.getPlanningFiles(planning_id).subscribe(
      (response) => {
        this.planning_files = response;
      },
      (error) => {
        console.error('Error fetching planning files', error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de la récupération des documents du planning.`,
          false,
          "Récupération des documents"
        );
      }
    );
  }

  refreshPlanning() {
    this.refresh.emit(true);
  }

  generateArray(n: number): number[] {
    return Array.from({length: n}, (_, i) => i);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/planning/new-planning/new-planning.component.ts